import { fireEvent, render, screen } from '@testing-library/react'
import Purpose from './Purpose'

describe('Purpose', () => {
  test('renders the principles and values section with accordions', () => {
    render(<Purpose />)

    expect(screen.getByRole('heading', { name: 'MARCO DE PRINCIPIOS Y VALORES' })).toBeTruthy()
    expect(screen.getByRole('button', { name: /principios políticos y sociales/i })).toBeTruthy()
    expect(screen.getByRole('button', { name: /principios vinculados a nuestra identidad y acción/i })).toBeTruthy()
    expect(screen.getByRole('button', { name: /principios sobre el conocimiento/i })).toBeTruthy()
    expect(screen.getByRole('button', { name: /valores relacionales y organizativos/i })).toBeTruthy()
  })

  test('keeps only one accordion open at a time', () => {
    render(<Purpose />)

    const first = screen.getByRole('button', { name: /principios políticos y sociales/i })
    const second = screen.getByRole('button', { name: /principios vinculados a nuestra identidad y acción/i })

    fireEvent.click(first)
    expect(first.getAttribute('aria-expanded')).toBe('true')

    fireEvent.click(second)
    expect(first.getAttribute('aria-expanded')).toBe('false')
    expect(second.getAttribute('aria-expanded')).toBe('true')
  })
})
